interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-label font-medium tracking-wide text-primary-700">
        <i className="ri-fire-line"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}